// eslint-disable-next-line consistent-return
export function collision(player, block) {
	if (player.x > block.x + block.weight ||
		player.x + player.width < block.x ||
		player.y > block.y + block.height ||
		player.y + player.height < block.y) {
		// console.log()
	} else {
		return true;
	}
}
